module.exports = __webpack_public_path__ + "img/VM-logo-transparent.c668f8c4.png";